import { BulkRequestCsvInfo } from '@components/UploadCSVModal';

export const handleBulkRequestFile = (csvStr: string) => {
  try {
    const FIELD_REQUIRED = 4;
    const result: BulkRequestCsvInfo[] = [];
    const sanitizedStr = csvStr.replace('"', '');
    const tab: string[] = sanitizedStr.split(/\r\n|\n/);
    for (let row = 0; row < tab.length; row++) {
      if (row > 0) {
        const rowItems = tab[row].split(',');
        if (rowItems.length === FIELD_REQUIRED) {
          const info: BulkRequestCsvInfo = {
            index: row,
            emailAddress: rowItems[0].replace(/"/g, '').trim(),
            fullName: rowItems[1].replace(/"/g, '').trim(),
            phoneCode: rowItems[2].replace(/"/g, '').trim(),
            phoneNumber: rowItems[3].replace(/"/g, '').trim(),
          };
          result.push(info);
        }
      }
    }

    return result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
